import { Component, OnInit, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';

@Component({
	selector: 'app-number-currency-input',
	templateUrl: './number-currency-input.component.html',
	styleUrls: ['./number-currency-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberCurrencyInputComponent extends InputComponent implements OnInit {
	public numericValue = 0;
	public numberString = '';
	public pattern = '[+-]?[0-9]*\.?[0-9]*';
	public minVal = 0;
	public maxVal = Number.MAX_SAFE_INTEGER;
	public allowNegative = true;
	public currencyLabel = 'USD';

	constructor(private domNode: ElementRef,protected cdr: ChangeDetectorRef) {
		super(cdr);
		super._domNode = this.domNode;
	}

	set currentValue(val: any) {
		super.currentValue = val;
		switch (this.attribute.type) {
			case 'string':
			case 'text':
				this.numericValue = NumberQualifierService.FromString('' + val, this.casting.format, this.casting.currency);
				break;
			default:
				this.numericValue = +val;
				break;
		}
		this.numberString = ''+this.numericValue;

	}
	get currentValue(): any {
		return super.currentValue;
	}

	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);
		let pattern = '';

		if (!!this.casting.range) {
			this.minVal = this.casting.range.min;
			this.maxVal = this.casting.range.max;
		}
		if (!!this.casting.currency) {
			const currencyCode = this.casting.currency.code;
			const currencySymbol = NumberQualifierService.CurrencyLUT[currencyCode];
			this.currencyLabel = currencyCode + ' ' + currencySymbol.symbol;
		}
		if (!!this.casting.plusMinus) {
			pattern += '[' + this.casting.plusMinus + ']';
		}

		pattern += '[0-9]*';
		if (!!this.casting.fixedDigits) {
			if (this.casting.fixedDigits > 0) {
				pattern += '\.?[0-9]{0,' + this.casting.fixedDigits + '}';
			}
			if (!!this.casting.precision) {
				pattern += '\.?[0-9]{0,' + this.casting.precision + '}';
			}
		}

	}

	NumberChanged(event: any) {
		this.numericValue = Number(event.target.value);
		if (this.numericValue < this.minVal) {
			this.numericValue = this.minVal;
		}
		if (this.numericValue > this.maxVal) {
			this.numericValue = this.maxVal;
		}
		switch (this.numericValue) {
			case null:
			case undefined:
				this.numberString = '';
				break;
			default:
				this.numberString = '' + this.numericValue;
		}
		switch (this.attribute.type) {
			case 'text':
			case 'string':
				if (this.hasCasting === true) {
					this.currentValue = NumberQualifierService.ToString(this.numericValue,
						this.casting.format, this.casting.fixedDigits, this.casting.negFormat, this.casting.currency);
					return;
				}
				break;
		}
		this.currentValue = '' + this.numericValue;
	}
}
